export const user = (data) => {
    return {
        type: "USER_INFOS",
        value: data
    }
}